import UnarchiveIcon from '@mui/icons-material/Unarchive';
import ButtonWithSpinner from '../../../../components/buttons/ButtonWithSpinner';
import { flatten, unique } from '../../../../utils/ArrayUtils';
import './UnarchiveSelectedLessons.scss';

import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

const defaultProps = {
  lessons: [],
  archiveLessonFunction: () => { },
  isArchiving: false,
  selectedLessonIds: [],
};

const UnarchiveSelectedLessons = (p) => {
  const { lessons, archiveLessonFunction, isArchiving, selectedLessonIds } = { ...defaultProps, ...filterUndefined(p) };
  const flattenLessons = flatten(lessons.map((subjectWithLessons) => subjectWithLessons.lessons));
  const archivedLessons = flattenLessons.filter((lesson) => lesson.meta.archived);

  const handleOnClick = async () => {
    const archivedSelectedLessons = unique(archivedLessons.filter((lesson) => selectedLessonIds.includes(lesson.id)), 'id');
    await archiveLessonFunction(archivedSelectedLessons, false);
  };

  return (
    <ButtonWithSpinner
      label='Unarchive'
      className='btn-primary unarchive-selected-lessons-action'
      disabled={archivedLessons.length === 0 || selectedLessonIds.length === 0 || isArchiving}
      loading={isArchiving}
      onClick={handleOnClick}
      startIcon={<UnarchiveIcon />}
      data-test='unarchive-selected-lessons-action'
    />
  );
};

export default UnarchiveSelectedLessons;
